// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"ed1b34d8","910":"c136e3a7"}[chunkId] + ".chunk.css";
};